(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lip-desktop-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lip-desktop-preview')) {
  customElements.define('lip-desktop-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (el, type, fn) => { if (el) el.addEventListener(type, fn, {signal}); };

      this.cards = [...this.querySelectorAll('.ldp__card')];
      if (!this.cards.length) return;
      this.dialog = this.querySelector('dialog');
      this.reader = this.querySelector('.ldp__reader');
      this.image = this.querySelector('[data-reader-image]');
      this.zoom = this.querySelector('[data-zoom]');
      this.active = 0;
      const count = this.cards.length;
      const mod = n => ((n % count) + count) % count;

      const render = () => {
        const card = this.cards[this.active];
        this.image.src = card.dataset.full;
        this.image.alt = card.dataset.label;
        this.querySelector('[data-title]').textContent = card.dataset.label;
        this.querySelector('[data-count]').textContent = `${this.active + 1} / ${count}`;
        this.reader.classList.remove('is-zoomed');
        this.zoom.setAttribute('aria-pressed', 'false');
        this.reader.scrollTo(0, 0);
      };

      const open = index => {
        if (!this.cards[index].querySelector('img')) return;
        this.active = index;
        render();
        this.dialog.showModal();
      };

      const step = delta => { this.active = mod(this.active + delta); render(); };

      this.cards.forEach((card, i) => listen(card, 'click', () => open(i)));
      listen(this.querySelector('[data-prev]'), 'click', () => step(-1));
      listen(this.querySelector('[data-next]'), 'click', () => step(1));
      listen(this.querySelector('[data-close]'), 'click', () => this.dialog.close());
      listen(this.zoom, 'click', () => {
        const on = this.reader.classList.toggle('is-zoomed');
        this.zoom.setAttribute('aria-pressed', String(on));
        if (!on) this.reader.scrollTo(0, 0);
      });
      listen(this.dialog, 'keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
      });
      listen(this, 'shopify:block:select', event => {
        const index = this.cards.indexOf(event.target.closest('.ldp__card'));
        if (index >= 0) open(index);
      });
      listen(this, 'shopify:block:deselect', () => { if (this.dialog.open) this.dialog.close(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-mobile-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lip-mobile-preview')) {
  customElements.define('lip-mobile-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (el, type, fn) => { if (el) el.addEventListener(type, fn, {signal}); };
      this.cards = [...this.querySelectorAll('.lmp__card')];
      if (!this.cards.length) return;
      this.stage = this.querySelector('.lmp__stage');
      this.dialog = this.querySelector('dialog');
      this.position = 0;
      this.target = 0;
      this.active = 0;
      this.frame = 0;
      this.suppressUntil = 0;
      const count = this.cards.length;
      const mod = n => ((n % count) + count) % count;
      this.draw = () => {
        const wide = window.matchMedia('(min-width: 769px)').matches;
        const radius = Math.min(this.stage.clientWidth * (wide ? .30 : .44), wide ? 330 : 210);
        const depth = wide ? 190 : 135;
        this.cards.forEach((card,i) => {
          const angle = (i - this.position) * Math.PI * 2 / count;
          const front = (Math.cos(angle) + 1) / 2;
          const x = Math.sin(angle) * radius;
          const z = (Math.cos(angle) - 1) * depth;
          const rotation = -Math.sin(angle) * 48;
          const scale = .85 + .15 * front;
          card.style.transform = `translate(-50%, -50%) translate3d(${x}px,0,${z}px) rotateY(${rotation}deg) scale(${scale})`;
          card.style.zIndex = String(Math.round(front * 100));
        });
      };
      const update = () => {
        this.active = mod(this.target);
        this.cards.forEach((card,i) => {
          card.tabIndex = i === this.active ? 0 : -1;
          card.setAttribute('aria-current', String(i === this.active));
        });
        const title = this.querySelector('[data-title]');
        const counter = this.querySelector('[data-count]');
        if (title) title.textContent = this.cards[this.active].dataset.label;
        if (counter) counter.textContent = `${this.active + 1} / ${count}`;
      };
      this.go = value => {
        cancelAnimationFrame(this.frame);
        this.target = value;
        update();
        const start = this.position;
        const begin = performance.now();
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 420;
        const tick = now => {
          const t = duration ? Math.min((now - begin) / duration, 1) : 1;
          this.position = start + (value - start) * (1 - Math.pow(1 - t, 3));
          this.draw();
          if (t < 1) this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      };
      const select = index => {
        let delta = index - this.active;
        if (delta > count / 2) delta -= count;
        if (delta < -count / 2) delta += count;
        this.go(this.target + delta);
      };
      const reader = this.querySelector('.lmp__reader');
      const zoom = this.querySelector('[data-zoom]');
      const open = () => {
        const card = this.cards[this.active];
        if (!card.querySelector('img')) return;
        const img = this.querySelector('[data-reader-image]');
        img.src = card.dataset.full;
        img.alt = card.dataset.label;
        reader.classList.remove('is-zoomed');
        zoom.setAttribute('aria-pressed','false');
        this.dialog.showModal();
        reader.scrollTo(0,0);
      };
      listen(this.querySelector('[data-prev]'), 'click', () => this.go(this.target - 1));
      listen(this.querySelector('[data-next]'), 'click', () => this.go(this.target + 1));
      listen(this.querySelector('[data-open]'), 'click', open);
      listen(this.querySelector('[data-close]'), 'click', () => this.dialog.close());
      listen(zoom, 'click', () => {
        const on = reader.classList.toggle('is-zoomed');
        zoom.setAttribute('aria-pressed',String(on));
        if (!on) reader.scrollTo(0,0);
      });
      this.cards.forEach((card,i) => listen(card, 'click', () => {
        if (performance.now() < this.suppressUntil) return;
        if (i === this.active) open(); else select(i);
      }));
      listen(this.stage, 'keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.target + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      let gesture = null;
      listen(this.stage,'pointerdown',event => {
        if (!event.isPrimary || event.button !== 0) return;
        gesture = {id:event.pointerId,x:event.clientX,y:event.clientY,origin:this.target,dx:0,drag:false};
      });
      listen(this.stage,'pointermove',event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (!gesture.drag && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {gesture = null;return;}
        if (!gesture.drag && Math.abs(dx) > 8) {
          gesture.drag = true;
          cancelAnimationFrame(this.frame);
          this.stage.setPointerCapture(event.pointerId);
        }
        if (!gesture.drag) return;
        gesture.dx = dx;
        this.position = gesture.origin - dx / (this.stage.clientWidth * .65);
        this.draw();
      });
      const finish = event => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const g = gesture;
        gesture = null;
        if (!g.drag) return;
        this.suppressUntil = performance.now() + 350;
        if (this.stage.hasPointerCapture(g.id)) this.stage.releasePointerCapture(g.id);
        const step = event.type !== 'pointercancel' && Math.abs(g.dx) > 30 ? (g.dx < 0 ? 1 : -1) : 0;
        this.go(g.origin + step);
      };
      listen(this.stage,'pointerup',finish);
      listen(this.stage,'pointercancel',finish);
      listen(this,'shopify:block:select',event => {
        const index = this.cards.indexOf(event.target.closest('.lmp__card'));
        if (index >= 0) select(index);
      });
      this.observer = new ResizeObserver(() => this.draw());
      this.observer.observe(this.stage);
      this.classList.add('is-ready');
      this.draw();
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-product-story"] && !Shopify.designMode) return;
  try {
    
(function(){function init(scope){scope.querySelectorAll('.lips').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='true';root.classList.add('is-ready');var rail=root.querySelector('.lips__examples'),items=Array.from(rail.querySelectorAll('.lips__example')),tabs=Array.from(root.querySelectorAll('[data-example-index]'));tabs.forEach(function(tab,i){tab.addEventListener('click',function(){var dx=items[i].getBoundingClientRect().left-rail.getBoundingClientRect().left;rail.scrollBy({left:dx,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})})});rail.addEventListener('scroll',function(){if(!matchMedia('(max-width:768px)').matches)return;var left=rail.getBoundingClientRect().left,best=0,d=Infinity;items.forEach(function(item,i){var delta=Math.abs(item.getBoundingClientRect().left-left);if(delta<d){d=delta;best=i}});tabs.forEach(function(tab,i){tab.setAttribute('aria-pressed',String(i===best))})},{passive:true});var dialog=root.querySelector('dialog'),reader=root.querySelector('.lips__reader'),image=reader.querySelector('img'),opener;root.querySelectorAll('[data-page-link]').forEach(function(link){link.addEventListener('click',function(e){if(!dialog.showModal)return;e.preventDefault();opener=link;image.src=link.href;image.alt=link.getAttribute('aria-label');reader.classList.remove('is-zoomed');root.querySelector('[data-zoom]').setAttribute('aria-pressed','false');dialog.showModal();reader.scrollTop=0;reader.scrollLeft=0})});dialog.addEventListener('close',function(){if(opener)opener.focus()});dialog.addEventListener('click',function(e){if(e.target===dialog)dialog.close()});root.querySelector('[data-zoom]').setAttribute('aria-pressed','false');root.querySelector('[data-zoom]').addEventListener('click',function(){this.setAttribute('aria-pressed',String(reader.classList.toggle('is-zoomed')))});root.querySelector('[data-buy-return]').addEventListener('click',function(){var button=document.querySelector('form[action*="/cart/add"] [type="submit"]');if(button){button.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});button.focus({preventScroll:true})}else window.scrollTo({top:0,behavior:'smooth'})});if('IntersectionObserver'in window){var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-entering');io.unobserve(entry.target)}})},{threshold:.12});root.querySelectorAll('.lips__example').forEach(function(el){io.observe(el)});root._lipsObserver=io}})}init(document);document.addEventListener('shopify:section:load',function(e){init(e.target)});document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('.lips').forEach(function(root){if(root._lipsObserver)root._lipsObserver.disconnect()})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-reviews-desktop"] && !Shopify.designMode) return;
  try {
    

(function(){
 function init(scope){
  scope.querySelectorAll('.liptd').forEach(function(root){
   if(root.dataset.ready)return;
   root.dataset.ready='1';
   var track=root.querySelector('[data-track]'),cards=Array.from(root.querySelectorAll('[data-card]')),bar=root.querySelector('[data-progress]'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
   if(!track||!cards.length)return;
   var update=function(){
    var max=track.scrollWidth-track.clientWidth,position=Math.max(0,Math.min(track.scrollLeft,max));
    var nearest=0,distance=Infinity;
    cards.forEach(function(card,i){var d=Math.abs(card.offsetLeft-24-position);if(d<distance){distance=d;nearest=i}});
    if(position>=max-2)nearest=cards.length-1;
    cards.forEach(function(card,i){card.classList.toggle('is-active',i===nearest)});
    if(bar)bar.style.width=(max>0?(1/cards.length+(position/max)*(1-1/cards.length))*100:100)+'%';
    if(prev)prev.disabled=position<=2;
    if(next)next.disabled=position>=max-2;
   };
   function move(direction){track.scrollBy({left:direction*(cards[0].getBoundingClientRect().width+12),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
   if(prev)prev.addEventListener('click',function(){move(-1)});
   if(next)next.addEventListener('click',function(){move(1)});
   track.addEventListener('scroll',update,{passive:true});
   if('ResizeObserver' in window){var ro=new ResizeObserver(update);ro.observe(track);root._liptdObserver=ro;}
   if('IntersectionObserver' in window){
    var enter=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){root.classList.add('motion-enter');enter.disconnect()}})},{threshold:.12});
    enter.observe(root);root._liptdEnter=enter;
   }
   update();
  });
 }
 init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target)});
 document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('.liptd').forEach(function(root){if(root._liptdObserver)root._liptdObserver.disconnect();if(root._liptdEnter)root._liptdEnter.disconnect()})});
 document.addEventListener('shopify:block:select',function(e){var card=e.target.closest('[data-card]');if(card&&card.closest('.liptd')){var track=card.closest('[data-track]');track.scrollTo({left:card.offsetLeft-24,behavior:'auto'})}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-reviews"] && !Shopify.designMode) return;
  try {
    

(function(){
 function init(scope){
  scope.querySelectorAll('.lipt').forEach(function(root){
   if(root.dataset.ready)return;
   root.dataset.ready='1';
   var track=root.querySelector('[data-track]'),cards=Array.from(root.querySelectorAll('[data-card]')),bar=root.querySelector('[data-progress]'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
   if(!track||!cards.length)return;
   var update=function(){
    var max=track.scrollWidth-track.clientWidth,position=Math.max(0,Math.min(track.scrollLeft,max));
    var nearest=0,distance=Infinity;
    cards.forEach(function(card,i){var d=Math.abs(card.offsetLeft-24-position);if(d<distance){distance=d;nearest=i}});
    if(position>=max-2)nearest=cards.length-1;
    cards.forEach(function(card,i){card.classList.toggle('is-active',i===nearest)});
    if(bar)bar.style.width=(max>0?(1/cards.length+(position/max)*(1-1/cards.length))*100:100)+'%';
    if(prev)prev.disabled=position<=2;
    if(next)next.disabled=position>=max-2;
   };
   function move(direction){track.scrollBy({left:direction*(cards[0].getBoundingClientRect().width+12),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
   if(prev)prev.addEventListener('click',function(){move(-1)});
   if(next)next.addEventListener('click',function(){move(1)});
   track.addEventListener('scroll',update,{passive:true});
   if('ResizeObserver' in window){var ro=new ResizeObserver(update);ro.observe(track);root._liptObserver=ro;}
   if('IntersectionObserver' in window){
    var enter=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){root.classList.add('motion-enter');enter.disconnect()}})},{threshold:.12});
    enter.observe(root);root._liptEnter=enter;
   }
   update();
  });
 }
 init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target)});
 document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('.lipt').forEach(function(root){if(root._liptObserver)root._liptObserver.disconnect();if(root._liptEnter)root._liptEnter.disconnect()})});
 document.addEventListener('shopify:block:select',function(e){var card=e.target.closest('[data-card]');if(card&&card.closest('.lipt')){var track=card.closest('[data-track]');track.scrollTo({left:card.offsetLeft-24,behavior:'auto'})}});
})();

  } catch(e) { console.error(e); }
})();
})();
